/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const KeyIcon = ({ width = 24, height = 24, hidden = false, title = 'Key' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M35.522 8.775 29.06 2.312a1.5 1.5 0 0 0-2.122 0L13.177 16.073A8.9 8.9 0 0 0 9 15a9 9 0 1 0 9 9 8.9 8.9 0 0 0-1.049-4.133l6.726-6.726 3.74 3.74a.75.75 0 0 0 1.061 0l3.344-3.344-4.27-4.271 1.231-1.231 4.27 4.271 2.469-2.47a.75.75 0 0 0 0-1.061ZM7.5 28.5a3 3 0 1 1 3-3 3 3 0 0 1-3 3Z"
    />
  </svg>`;
};
